import React, { useEffect, useState } from "react"
import apiRequest from "../../lib/http"
import BrandAccess from "./BrandAccess"

const asList = (value) => (Array.isArray(value) ? value : [])

const BrandAccessPanel = ({ userId, homeCompany }) => {
  const [myBrands, setMyBrands] = useState([])

  useEffect(() => {
    if (!userId) return

    let live = true

    const load = async () => {
      try {
        const response = await apiRequest.get('/company/mine')
        if (live) setMyBrands(asList(response?.data?.data))
      } catch (error) {
        // The section is a passenger on the account form. It disappears rather than taking the
        // page down with it, which is also the right answer when the caller may not read brands.
        if (live) setMyBrands([])
      }
    }

    load()

    return () => { live = false }
  }, [userId])

  if (!userId || myBrands.length <= 1) return null

  return <BrandAccess userId={userId} myBrands={myBrands} homeCompany={homeCompany} />
}

export default BrandAccessPanel
